import { useState, useEffect } from "react";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import "./tutorial.css";

function Tutorial({
  tutorialImgs = [],
  timerMode = "run",
  showHeader = true,
  onFinish,
  defaultPath,
}) {
  const { startTimer, pauseTimer } = useGame();

  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  const [step, setStep] = useState(0);
  const [isFade, setIsFade] = useState(false); // ⭐ 추가

  const nextStep = () => {
    if (step === tutorialImgs.length - 1) {
      // onFinish && onFinish();
      onFinish &&
        onFinish({
          defaultPath,
          state: { DateVal: "DATA2", titImgClass: "infoTit2" },
        });
      return;
    }

    setIsFade(true); // 1. 사라지기 시작

    setTimeout(() => {
      setStep((prev) => prev + 1); // 2. 이미지 교체
      setIsFade(false); // 3. 다시 나타남
    }, 300); // CSS 시간과 동일
  };

  return (
    <div className="box3 content_box1 box_storage_bg ans0001">
      <Header backgroundNone0={true} />

      <div className="box_con con_box7 con_box_storage">
        <div className="missionDivTu">
          <div className="missionDiTu">
            <div className="mission_content pdTB65120">
              <div className="imgis img01">
                {tutorialImgs[step] && (
                  <div
                    className={`imgis img0${step + 1} tutorial-motion ${
                      isFade ? "fade-out" : "fade-in"
                    }`}
                  >
                    <img
                      src={tutorialImgs[step]}
                      className={`tutorial-${step + 1}`}
                      alt={`tutorial-${step + 1}`}
                    />
                  </div>
                )}
              </div>

              <div id="box_ft3">
                <button type="button" className="inputBtn02" onClick={nextStep}>
                  {step === tutorialImgs.length - 1 ? "다음" : "다음"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tutorial;
